import { Controller } from "@hotwired/stimulus"
import React from "react"
import ReactDOM from "react-dom/client"
import WalletsRevolutionScene from "../components/wallets-revolution-scene"

export default class extends Controller {

  connect() {
    this.root = ReactDOM.createRoot(this.element)
    this.root.render(
      <WalletsRevolutionScene/>
    )
  }

  disconnect() {
     this.root.unmount()
  }
  
}
